import { useEffect, useState } from 'react';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import axios from 'axios';

//
// Глобальный кэш для анимаций: при первом запросе сохраняется blob URL,
// который используется при последующих обращениях
//
const animationCache = new Map<string, string>();

interface BattleLottiePlayerProps {
  preloaderStyle: string | null;
  lottieUrl: string | null;
  isLocked?: boolean;
  lockedReason?: string;
  isLoop?: boolean;
}

export const BattleLottiePlayer = ({
                                     preloaderStyle,
                                     lottieUrl,
                                     isLocked,
                                     lockedReason,
                                     isLoop,
                                   }: BattleLottiePlayerProps) => {
  const [animationUrl, setAnimationUrl] = useState<string | null>(null);
  const [error, setError] = useState<boolean>(false);

  useEffect(() => {
    if (lottieUrl) {
      // Если анимация уже закеширована, используем её
      if (animationCache.has(lottieUrl)) {
        setAnimationUrl(animationCache.get(lottieUrl)!);
        return;
      }
      // Запрашиваем файл как Blob
      axios
        .get(lottieUrl, { responseType: 'blob' })
        .then((response) => {
          // Проверяем, что ответ успешный и Blob не пустой
          if (response.status === 200 && response.data && response.data.size > 0) {
            const blobUrl = URL.createObjectURL(response.data);
            animationCache.set(lottieUrl, blobUrl);
            setAnimationUrl(blobUrl);
          } else {
            console.error("Получен пустой Blob или неверные данные:", response);
            setError(true);
          }
        })
        .catch((err) => {
          console.error("Ошибка загрузки Lottie-анимации:", err);
          setError(true);
        });
    }
  }, [lottieUrl]);

  if (error) {
    return <div>Error loading animation.</div>;
  }

  if (!animationUrl) {
    return (
      <div
        className={`${
          preloaderStyle === 'round' ? 'rounded-full' : 'rounded-xl'
        } w-full aspect-[1/1] bg-slate-700 animate-pulse`}
      />
    );
  }

  return (
    <div
      className="relative rounded-xl overflow-hidden"
      style={{ width: 70, height: 70 }}
    >
      <DotLottieReact
        src={animationUrl}
        loop={isLoop}
        autoplay
        height={70}
        width={70}
        useFrameInterpolation={false}
      />
      {isLocked && (
        <div className="absolute top-0 w-full h-full flex flex-col justify-center items-center bg-[#0F152A]/[.8] backdrop-blur p-1">
          <span className="nw-icon-locked text-3xl text-white"></span>
          <div className="absolute bottom-3 text-[10px] font-bold">
            {lockedReason}
          </div>
        </div>
      )}
    </div>
  );
};
